/*--------------------------------------------------------------------------*
 * タブ
 *--------------------------------------------------------------------------*/
module Module_SwitchTab {
	import Model_PrefAjax = Module_PrefAjax.Model_PrefAjax;

	export class Model_SwitchTab {
		// 選択したタブ・パネルを開く
		openTabAndPnl(tab: JQuery, pnl:JQuery): void {
			tab.prop("checked", true).attr("aria-selected", "true");
			pnl.attr("aria-hidden", "false");
		}

		switchPnl(tab: JQuery, callback?: callbackType): void {
			enum Mode {
				Pc = "pc",
				Sp = "sp"
			}

			const view: this     = this,
				pnl: JQuery      = $("#"+tab.attr("aria-describedby")),
				allPnls: JQuery  = pnl.siblings('[data-switch="panel"]'),
				allTabs: JQuery  = tab.parents('[data-switch="tablist"]').find('[data-switch="tab"]'),
				pref_id: string  = tab.val(),
				duration: number = 0,
				ajax: Model_PrefAjax = new Model_PrefAjax();

			callback = callback ? callback : function(){};

			// タブが既に選択されているとき実行しない
			if(tab.attr("aria-selected") === "true") return;

			// すべてのタブ・パネルを閉じる
			allTabs.attr("aria-selected", "false");
			allPnls.attr("aria-hidden", "true");

			// 市区町村パネル生成
			if(!$('#prefPnl'+pref_id+' ul').length){
				ajax.makePanel(pref_id, Mode.Pc).done(function(result: JQueryXHR): void {
					$('#prefPnl'+pref_id).html(String(result));

					// 選択したタブ・パネルを開く
					view.openTabAndPnl(tab, pnl);

					// callbackの実行
					callback();
				});
			} else {
				// 選択したタブ・パネルを開く
				view.openTabAndPnl(tab, pnl);

				// callbackの実行
				callback();
			}
		}
	}
}
